export default {
  s: '%d ثانیه',
  smicro: '%d ث',
  smid: '%d ثانی',

  ss: '%d ثانیې',
  ssmicro: '%d ث',
  ssmid: '%d ثانی',

  m: '%d دقیقه',
  mmicro: '%d دق',
  mmid: '%d دقی',

  mm: '%d دقیقې',
  mmmicro: '%d دق',
  mmmid: '%d دقی',

  h: '%d ساعت',
  hmicro: '%d س',
  hmid: '%d ساعت',

  hh: '%d ساعتونه',
  hhmicro: '%d س',
  hhmid: '%d ساعتونه',

  d: '%d ورځ',
  dmicro: '%d و',
  dmid: '%d ورځ',

  dd: '%d ورځې',
  ddmicro: '%d و',
  ddmid: '%d ورځې',
};
